import {isEqual} from 'es-toolkit';

import type {NamedSetState} from 'app/gemStore/devtools';
import type {NewState, ComponentUrlState} from 'app/utils/urlStateElements/interfaces';

import type {UrlStateComponentSlice, UrlStateComponentState} from './types';

const defaultState: UrlStateComponentState = {
    hashPath: null,
    queryPath: null,
    hashState: null,
    queryState: null,
};

export const createUrlStateComponentSlice = (set: NamedSetState<UrlStateComponentSlice>, get: () => UrlStateComponentSlice) => ({
    urlStateComponent: {...defaultState} as UrlStateComponentState,
    historyChange: ({hashPath, queryPath}: {hashPath: string; queryPath: string}) =>
        set({urlStateComponent: {...get().urlStateComponent, hashPath, queryPath}}, false, 'urlState/historyChange'),
    setParsedURLState: ({hashState, queryState}: {hashState: NewState; queryState: ComponentUrlState}) => {
        const current = get().urlStateComponent;
        if (isEqual(hashState, current.hashState) && isEqual(queryState, current.queryState)) {
            return;
        }

        set({urlStateComponent: {...current, hashState, queryState}}, false, 'urlState/setParsedURLState');
    },
});
